<!-- eslint-disable vue/no-unused-properties -->
<script setup lang="ts">
  import { computed, ref, watch } from "vue";
  import { format } from "@/utils/common";
  import { $t } from "@/locales";

  defineOptions({ name: "CurrentExchange" });

  interface Props {
    /** Theme schema */
    currentExchangeRate: number;
    /** Current language */
    lang: App.I18n.LangType;
    direction: Direction;
    /** Language options */
    /** Show tooltip */
    showTooltip?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), {
    showTooltip: true,
  });
  const formattedRate = computed(() => format(props.currentExchangeRate));
  const isFlashing = ref(false);

  // Watch for changes in currentExchangeRate
  watch(
    () => props.currentExchangeRate,
    () => {
      isFlashing.value = true;
      // Remove the flash effect after animation completes
      setTimeout(() => {
        isFlashing.value = false;
      }, 1000); // 1000ms matches the total animation duration
    }
  );
</script>

<template>
  <NTooltip trigger="hover" :delay="1000">
    <template #trigger>
      <div
        class="min-w-30 max-w-38 flex items-center justify-between text-right text-gray-600 transition-all duration-1000 dark:text-gray-400 mx-1 gap-1"
        :style="{ direction: props.direction }"
      >
        <span class="text-sm text-gray-500 truncate" style="max-width: 150px">
          {{ $t("billing.exchangeRate") }}
        </span>

        <span
          v-if="formattedRate && formattedRate !== '0'"
          class="inline-block rounded"
          :class="{ 'flash-highlight': isFlashing }"
        >
          {{ formattedRate }}
        </span>
        <LoadingStaticIcon v-else class="animate-spin" />
      </div>
    </template>
    {{ $t("billing.exchangeRateUSDT") }}
  </NTooltip>
</template>
